import * as React from 'react';
import { translate } from 'react-i18next';
import * as _ from 'lodash';
import OwlCarousel from 'react-owl-carousel2';
import api from '../services';
import { getCookie } from '../helpers/index';

const slideOptions = {
	items: 1,
	margin: 0,
	dots: true,
	rewind: true,
	autoplay: true,
	loop: true,
	nav: true
};

class HomeTopSlides extends React.Component<any, any> {

	constructor(props) {
		super(props);
		this.state = {
			data_slides: [],
			loading: true
		};
	}

	componentDidMount() {
		api.getPosts({
			post_type: 'slide'
		}).then(res => {
			this.setState({
				loading: false
			});
			this.setState({
				data_slides: res.data
			});
		}).catch(() => {
			this.setState({
				loading: false
			});
		});
	}

	render() {

		const { data_slides } = this.state;

		var language = 'vn';

		if(getCookie('language_landing')) {
			language = getCookie('language_landing');
		}

		let filteredList = _.filter(data_slides, function (post) {
			return _.some(post.custom_fields, { 'value': language, 'key': 'language' });
		});

		const slides_sort = filteredList.sort(function (slideA, slideB) {
			return slideA.post_parent - slideB.post_parent;
		});

		const slides = slides_sort.map((item) => {
			var link = '';
			if (item.custom_fields.length > 0) {
				link = item.custom_fields[1]['value'];
				return (
					<div className="item" key={item.post_id}>
						<a className="imgSlide" href={link}  style={{ background: `url(${item.post_thumbnail.link}) no-repeat center center/cover` }}></a>
						<div className="txtSlide">
							<div className="container">
								<div className="text-center">
									<h6 className="wow fadeInUp">{item.post_title}</h6>
									<p className="wow fadeIn" data-wow-delay="0.5s">
										{item.post_content}
									</p>
									<div className="more wow fadeIn" data-wow-delay="0.5s">
										<a href={link} className="cl1" target="_blank">{this.props.t('view_more')}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});

		const owlSlides = filteredList.length == 0 ? <div></div> :
			<div>
				<OwlCarousel options={slideOptions}>
					{slides}
				</OwlCarousel>
			</div>;

		return (
			<div>
				<div className="clearfix"></div>
				<div className="slide slideCover">
					{owlSlides}
				</div>
				<div className="clearfix"></div>
				{this.state.loading ?
					<div className="loadingPage active"><img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default translate('translations')(HomeTopSlides);



// WEBPACK FOOTER //
// ./src/components/HomeTopSlides.tsx